import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VALIDATOR_ONLY_SPACES } from '../shared/constants/helpers.const';

@Injectable({ providedIn: 'root' })
export class TransactionFormProvider {
  transactionUpdateForm: FormGroup;

  constructor(private fb: FormBuilder) {}

  initForm(data?: any): FormGroup {
    return (this.transactionUpdateForm = this.fb.group({
      transactionType: [data?.transactionType || ''],
      debtor: [data?.debtor || null, [Validators.required]],
      ccy: [data?.ccy || '', [Validators.required]],
      date: [data?.date, [Validators.required, VALIDATOR_ONLY_SPACES]],
      amount: [data?.amount, [Validators.required]],
      file: [data?.file || null, [Validators.required]],
    }));
  }
}
